import { FC } from 'react';
import { SpaEntityType } from 'shared-types/Spa';
import { FormStep } from '../../../types';
import {
  ItemWrapper,
  SpaImage,
  SpaImageWrapper,
  ExperiencesGroupWrapper,
} from '../ExperiencesGroup.styles';
import {
  ExperiencesGroupOptionsBase,
  renderExperienceDetailComponent,
} from './ExperiencesGroupOptionsBase';
interface Props {
  selectionGroup: Omit<FormStep, 'step' | 'type'>;
  allOptionsIncluded?: boolean;
  spaExperiences: Array<Partial<SpaEntityType> & { startTime?: string }>;
  plusMinusSpaOption: (
    type: 'plus' | 'minus',
    id: number,
    optionId: number,
    startTime?: string
  ) => void;
  totalGuests: number;
  dayNumber: number;
}

export const ExperiencesGroupOptionsDesktop: FC<Props> = (props) => {
  return (
    <ExperiencesGroupOptionsBase
      {...props}
      renderExperienceItem={({ exp, experienceDetailProps, imageUrl, isClasses }) => (
        <ItemWrapper key={exp.id} noImage={isClasses} data-unavailable={exp?.unAvailable}>
          <>
            {renderExperienceDetailComponent(experienceDetailProps, isClasses)}
            {isClasses ? (
              <div />
            ) : (
              <SpaImageWrapper isFullDim>
                <SpaImage url={imageUrl} />
              </SpaImageWrapper>
            )}
          </>
        </ItemWrapper>
      )}
      renderGroup={(content) => <ExperiencesGroupWrapper>{content}</ExperiencesGroupWrapper>}
    />
  );
};
